import React from 'react';

import Button, { BUTTON_COLORS } from 'js/src/components/common/ui/Button';

type Props = {
    onClick: () => void;
};
const StartRecordingButton: React.FC<Props> = ({ onClick }) => {
    return (
        <Button
            text="Start recording"
            color={BUTTON_COLORS.DANGER}
            iconLeft="circle"
            onClick={onClick}
        />
    );
};
export default React.memo(StartRecordingButton);
